import styled from 'styled-components';
import { screenMd } from 'constants/styles/breakpoints';

export const Body = styled.div<{ header?: boolean; topBarHeight?: number }>`
  display: flex;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.default.colors.body.bg};
  transition: transform 0.6s;
  transform: initial;

  ${({ topBarHeight }) =>
    topBarHeight !== undefined &&
    `
		--layout-top-bar-height: ${topBarHeight}px;
	`}

  ${screenMd} {
    padding-left: 140px;
  }

  ${({ header }) =>
    header &&
    `
		padding-top: 64px;
		min-height: calc(100vh - 64px);
		${screenMd} {
			min-height: 100vh;
		}
	`}
`;

export const Main = styled.div<{ translateY: string }>`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  transition: all 0.3s;

  ${({ translateY }) =>
    translateY &&
    `
		padding-top: ${translateY}
	`}
`;

export const Content = styled.div<{ isMobile?: boolean; top?: number }>`
  flex: 1 1 auto;
  width: 100%;
  padding: 20px;
  ${({ top }) => top && `padding-top: ${top}px`}
  box-sizing: border-box;
  min-height: 0;

  ${({ isMobile }) =>
    isMobile &&
    `
		padding: 0;
    ${({ top }) => top && `padding-top: ${top}px`}
	`}
`;

export const TopBarsStack = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
